import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type SupportChatStoreType = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  conversationId: number | null;
  setConversationId: (conversationId: number | null) => void;
};

// Kept in localStorage so a page reload continues the conversation; logout clears localStorage.
export const useSupportChatStore = create<SupportChatStoreType>()(
  persist(
    (set) => ({
      isOpen: false,
      setIsOpen: (isOpen) => set({ isOpen }),
      conversationId: null,
      setConversationId: (conversationId) => set({ conversationId })
    }),
    {
      name: 'support-chat',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ conversationId: state.conversationId })
    }
  )
);
